import { Tag } from "@/components/elements/Tag";
import { FCC } from "@/types/common";
import { black, orange } from "@/theme/colors";

type CaseTalentAnotherStatusProps = {
  isAnotherStatus?: boolean;
};

export const CaseTalentAnotherStatus: FCC<CaseTalentAnotherStatusProps> = ({ isAnotherStatus }) => {
  const title = isAnotherStatus ? "あり" : "なし";
  const color = isAnotherStatus ? orange[97] : black[99];
  return <Tag variant="bold" title={title} color={color} textColor={black[30]} fontWeight={400} />;
};
